export const name = "FLOAT64";
export const summary = `Converts a JSON number to a SQL \`FLOAT64\` value.`;
export const reference = `
## FLOAT64

Converts a JSON number to a SQL \`FLOAT64\` value.

\`\`\`
FLOAT64(
  json_expr
  [, wide_number_mode => { 'exact' | 'round' }]
)
\`\`\`

### Description

Converts a JSON number to a SQL \`FLOAT64\` value.

Arguments:

- \`json_expr\`: JSON. For example:

- \`wide_number_mode\`: A named argument with a \`STRING\` value. Defines what happens with a number that can't be represented as a \`FLOAT64\` without loss of precision. This argument accepts one of the two case-sensitive values:


### Return type

\`FLOAT64\`


### Examples



\`\`\`
SELECT FLOAT64(JSON '9.8') AS velocity;

/*----------*
 | velocity |
 +----------+
 | 9.8 |
 *----------*/
\`\`\`



\`\`\`
SELECT FLOAT64(JSON_QUERY(JSON '{"vo2_max": 39.1, "age": 18}', "$.vo2_max")) AS vo2_max;

/*---------*
 | vo2_max |
 +---------+
 | 39.1 |
 *---------*/
\`\`\`



\`\`\`
SELECT FLOAT64(JSON '18446744073709551615', wide_number_mode=>'round') as result;

/*------------------------*
 | result |
 +------------------------+
 | 1.8446744073709552e+19 |
 *------------------------*/
\`\`\`



\`\`\`
SELECT FLOAT64(JSON '18446744073709551615') as result;

/*------------------------*
 | result |
 +------------------------+
 | 1.8446744073709552e+19 |
 *------------------------*/
\`\`\`

The following examples show how invalid requests are handled:



\`\`\`
-- An error is thrown if JSON isn't of type FLOAT64.
SELECT FLOAT64(JSON '"strawberry"') AS result;
SELECT FLOAT64(JSON 'null') AS result;

-- An error is thrown because \`wide_number_mode\` is case-sensitive and not "exact" or "round".
SELECT FLOAT64(JSON '123.4', wide_number_mode=>'EXACT') as result;
SELECT FLOAT64(JSON '123.4', wide_number_mode=>'exac') as result;

-- An error is thrown because the number can't be converted to DOUBLE without loss of precision
SELECT FLOAT64(JSON '18446744073709551615', wide_number_mode=>'exact') as result;

-- Returns a SQL NULL
SELECT SAFE.FLOAT64(JSON '"strawberry"') AS result;
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/json_functions
`;
